<template>
  <div class="container-fluid py-4">
    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body px-0 pb-2">
            <div class="fees-layout">
              <!-- Left Sidebar -->
              <div class="fees-sidebar">
                <div class="fees-sidebar-header">
                  <strong>Fees & Taxes</strong>
                </div>
                <!-- Default item -->
                <div
                  class="fees-sidebar-item"
                  :class="{ active: activeIndex === -1 }"
                  @click="activeIndex = -1"
                >
                  <span>DEFAULT</span>
                </div>
                <!-- Exception items -->
                <div
                  v-for="(exception, index) in data.exceptions"
                  :key="index"
                  class="fees-sidebar-item"
                  :class="{ active: activeIndex === index }"
                  @click="activeIndex = index"
                >
                  <span>EXCEPTION {{ index + 1 }}</span>
                  <span class="fees-sidebar-actions">
                    <i
                      class="material-icons fees-delete-icon"
                      title="Delete"
                      @click.stop="deleteException(index)"
                    >delete</i>
                  </span>
                </div>
                <!-- Add Exception button -->
                <div class="fees-sidebar-add" @click="addException()">
                  <i class="material-icons">add</i>
                  <span>ADD EXCEPTION</span>
                </div>
              </div>

              <!-- Right Panel -->
              <div class="fees-panel">
                <!-- DEFAULT view -->
                <template v-if="activeIndex === -1">
                  <div class="fees-panel-header">
                    <h5 class="mb-0">DEFAULT — MINTY TRANSACTION FEE</h5>
                  </div>
                  <div class="fees-panel-body">
                    <div v-for="(item, index) in data.default" :key="index" class="fees-group">
                      <div class="fees-group-title">{{ item.title }}</div>
                      <table class="table fees-table">
                        <thead>
                          <tr>
                            <th>Payment Method</th>
                            <th>Type</th>
                            <th>Percentage</th>
                            <th>Fixed Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(subItem, subIndex) in item.item" :key="subIndex">
                            <td class="align-middle">{{ subItem.name }}</td>
                            <td>
                              <select v-model="subItem.selectedOption" class="form-select form-select-sm fees-select">
                                <option value="percentage">Percentage</option>
                                <option value="fixed">Fixed Amount</option>
                                <option value="combined">Combined</option>
                              </select>
                            </td>
                            <td>
                              <div
                                v-if="subItem.selectedOption === 'percentage' || subItem.selectedOption === 'combined'"
                                class="input-group input-group-sm fees-input-group"
                              >
                                <input
                                  v-model="subItem.percentageDefaulValue"
                                  type="text"
                                  class="form-control"
                                  placeholder="0"
                                >
                                <span class="input-group-text">%</span>
                              </div>
                              <span v-else class="text-muted">—</span>
                            </td>
                            <td>
                              <div
                                v-if="subItem.selectedOption === 'fixed' || subItem.selectedOption === 'combined'"
                                class="input-group input-group-sm fees-input-group"
                              >
                                <span class="input-group-text">$</span>
                                <input
                                  v-model="subItem.fixedDefaulValue"
                                  type="text"
                                  class="form-control"
                                  placeholder="0.00"
                                >
                              </div>
                              <span v-else class="text-muted">—</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>

                <!-- EXCEPTION view -->
                <template v-else-if="data.exceptions[activeIndex]">
                  <div class="fees-panel-header">
                    <h5 class="mb-0">EXCEPTION {{ activeIndex + 1 }} — MINTY TRANSACTION FEE</h5>
                  </div>
                  <div class="fees-panel-body">
                    <!-- Merchant selection at top -->
                    <div class="fees-merchant-section">
                      <label class="form-label fw-bold">Apply to Merchants:</label>
                      <Select2
                        :settings="{ multiple: true, placeholder: 'Select merchants...' }"
                        v-model="data.exceptions[activeIndex].merchant"
                        :options="merchants"
                        class="auto-height"
                      />
                    </div>

                    <!-- Fee tables -->
                    <div
                      v-for="(item, itemIndex) in data.exceptions[activeIndex].items"
                      :key="itemIndex"
                      class="fees-group"
                    >
                      <div class="fees-group-title">{{ item.title }}</div>
                      <table class="table fees-table">
                        <thead>
                          <tr>
                            <th>Payment Method</th>
                            <th>Type</th>
                            <th>Percentage</th>
                            <th>Fixed Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(subItem, subIndex) in item.item" :key="subIndex">
                            <td class="align-middle">{{ subItem.name }}</td>
                            <td>
                              <select v-model="subItem.selectedOption" class="form-select form-select-sm fees-select">
                                <option value="percentage">Percentage</option>
                                <option value="fixed">Fixed Amount</option>
                                <option value="combined">Combined</option>
                              </select>
                            </td>
                            <td>
                              <div
                                v-if="subItem.selectedOption === 'percentage' || subItem.selectedOption === 'combined'"
                                class="input-group input-group-sm fees-input-group"
                              >
                                <input
                                  v-model="subItem.percentageDefaulValue"
                                  type="text"
                                  class="form-control"
                                  placeholder="0"
                                >
                                <span class="input-group-text">%</span>
                              </div>
                              <span v-else class="text-muted">—</span>
                            </td>
                            <td>
                              <div
                                v-if="subItem.selectedOption === 'fixed' || subItem.selectedOption === 'combined'"
                                class="input-group input-group-sm fees-input-group"
                              >
                                <span class="input-group-text">$</span>
                                <input
                                  v-model="subItem.fixedDefaulValue"
                                  type="text"
                                  class="form-control"
                                  placeholder="0.00"
                                >
                              </div>
                              <span v-else class="text-muted">—</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>

                <!-- Save button -->
                <div class="fees-panel-footer">
                  <button class="btn bg-gradient-success" @click="save()">Save</button>
                </div>
              </div>
            </div>

            <div class="position-fixed top-1 end-1 z-index-2 message-success">
              <material-snackbar
                v-if="snackbar === 'danger' || snackbar === 'success'"
                title=""
                date=""
                :description="message"
                :icon="{ component: 'campaign', color: 'white' }"
                :color="snackbar"
                :close-handler="closeSnackbar"
              />
            </div>
            <material-loading :active="loaderActive" />
            <ModalConfirm
              id="deleteExceptionConfirm"
              :message="'Are you sure you want to delete this exception?'"
              :processYes="confirmDeleteException"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from 'vue3-select2-component';
import SettingFeesAndTaxes from '../../services/settingFeesAndTaxes.service'
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";

export default {
  components: {
    Select2,
    MaterialSnackbar,
    MaterialLoading,
    ModalConfirm
  },
  mounted() {
    this.showLoader();
    this.loadList();
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      activeIndex: -1,
      deleteIndex: -1,
      data: {
        default: [
          {
            title_id: 1,
            title: 'Online Payment',
            item: [
              { id: 1, name: 'VISA', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 2, name: 'MASTER CARD', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 3, name: 'AMEX', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 4, name: 'PAYNOW', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 5, name: 'Other', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 6, name: 'Foreign Cards', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 }
            ]
          },
          {
            title_id: 2,
            title: 'Via Stripe Reader Payment',
            item: [
              { id: 1, name: 'VISA', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 2, name: 'MASTER CARD', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 3, name: 'AMEX', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 4, name: 'PAYNOW', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 5, name: 'Other', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 6, name: 'Foreign Cards', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 }
            ]
          }
        ],
        exceptions: [],
      },
      merchants: []
    };
  },
  methods: {
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    loadList() {
      SettingFeesAndTaxes.getSettingFeesAndTaxes().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.merchants = response.data.data.merchant_dropdown;
            if (
              response.data.data.items &&
              response.data.data.items.default &&
              response.data.data.items.default.length > 0 &&
              response.data.data.items.default[0].item &&
              response.data.data.items.default[0].item.length > 0
            ) {
              this.data = response.data.data.items;
            }
            if (!this.data.exceptions) {
              this.data.exceptions = [];
            }
            // Clamp activeIndex to valid range after data reload
            if (this.activeIndex >= 0 && this.activeIndex >= this.data.exceptions.length) {
              this.activeIndex = this.data.exceptions.length > 0 ? this.data.exceptions.length - 1 : -1;
            }
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    addException() {
      if (!this.data.exceptions) {
        this.data.exceptions = [];
      }
      this.data.exceptions.push({
        id: 0,
        merchant: [],
        items: [
          {
            title_id: 1,
            title: 'Online Payment',
            item: [
              { id: 1, name: 'VISA', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 2, name: 'MASTER CARD', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 3, name: 'AMEX', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 4, name: 'PAYNOW', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 5, name: 'Other', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 6, name: 'Foreign Cards', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 }
            ]
          },
          {
            title_id: 2,
            title: 'Via Stripe Reader Payment',
            item: [
              { id: 1, name: 'VISA', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 2, name: 'MASTER CARD', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 3, name: 'AMEX', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 4, name: 'PAYNOW', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 5, name: 'Other', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 },
              { id: 6, name: 'Foreign Cards', selectedOption: 'combined', percentageDefaulValue: 0, fixedDefaulValue: 0 }
            ]
          }
        ]
      });
      this.activeIndex = this.data.exceptions.length - 1;
    },
    deleteException(index) {
      this.deleteIndex = index;
      document.querySelector('.btn-confirm-modal').click();
    },
    adjustActiveIndexAfterDelete(deletedIndex) {
      if (this.data.exceptions.length === 0) {
        this.activeIndex = -1;
      } else if (this.activeIndex === deletedIndex) {
        // Deleted the active one: stay at same index or go to last
        this.activeIndex = deletedIndex < this.data.exceptions.length ? deletedIndex : this.data.exceptions.length - 1;
      } else if (this.activeIndex > deletedIndex) {
        // Active one shifted down
        this.activeIndex--;
      }
    },
    confirmDeleteException() {
      var index = this.deleteIndex;
      if (index < 0) return;
      document.querySelector('#modalConfirm [data-bs-dismiss="modal"]').click();
      var exception = this.data.exceptions[index];
      if (exception.id && exception.id > 0) {
        this.showLoader();
        SettingFeesAndTaxes.deleteException(exception.id).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.data.exceptions.splice(index, 1);
              this.adjustActiveIndexAfterDelete(index);
              this.snackbar = "success";
              this.message = "Delete successfully!";
              this.setTimeOutNotification();
              this.loadList();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      } else {
        this.data.exceptions.splice(index, 1);
        this.adjustActiveIndexAfterDelete(index);
      }
      this.deleteIndex = -1;
    },
    save() {
      if (this.activeIndex === -1) {
        this.saveDefault();
      } else {
        this.saveException();
      }
    },
    saveDefault() {
      this.showLoader();
      SettingFeesAndTaxes.saveDefault({ default: this.data.default }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Save successfully!";
            this.setTimeOutNotification();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    saveException() {
      var exception = this.data.exceptions[this.activeIndex];
      if (!exception) return;

      var payload = {
        merchant: exception.merchant,
        items: exception.items,
        name: ''
      };

      this.showLoader();

      if (exception.id && exception.id > 0) {
        SettingFeesAndTaxes.updateException(exception.id, payload).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Save successfully!";
              this.setTimeOutNotification();
              this.loadList();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      } else {
        SettingFeesAndTaxes.createException(payload).then(
          (response) => {
            if (response.data.result.isSuccess) {
              exception.id = response.data.data.id;
              this.snackbar = "success";
              this.message = "Save successfully!";
              this.setTimeOutNotification();
              this.loadList();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    }
  },
};
</script>

<style scoped>
.fees-layout {
  display: flex;
  min-height: 600px;
}

/* ── Left Sidebar ── */
.fees-sidebar {
  width: 220px;
  min-width: 220px;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
}

.fees-sidebar-header {
  padding: 12px 16px;
  font-size: 14px;
  border-bottom: 1px solid #e0e0e0;
}

.fees-sidebar-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 13px;
  border-left: 3px solid transparent;
  border-bottom: 1px solid #e0e0e0;
  transition: background 0.15s;
}

.fees-sidebar-item:hover {
  background: #f5f5f5;
}

.fees-sidebar-item.active {
  background: #3b5998;
  color: #fff;
  border-left-color: #3b5998;
  border-radius: 0;
}

.fees-sidebar-item.active .fees-delete-icon {
  color: #ffcdd2;
}

.fees-sidebar-actions {
  display: flex;
  align-items: center;
}

.fees-delete-icon {
  font-size: 16px;
  color: #999;
  cursor: pointer;
  transition: color 0.15s;
}

.fees-delete-icon:hover {
  color: #e53935;
}

.fees-sidebar-add {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 13px;
  color: #555;
  border-top: 1px solid #e0e0e0;
  margin-top: auto;
}

.fees-sidebar-add:hover {
  background: #f5f5f5;
}

.fees-sidebar-add .material-icons {
  font-size: 18px;
}

/* ── Right Panel ── */
.fees-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
}

.fees-panel-header {
  padding: 12px 20px;
  border-bottom: 1px solid #e0e0e0;
}

.fees-panel-header h5 {
  font-size: 15px;
  font-weight: 600;
}

.fees-panel-body {
  padding: 20px;
  flex: 1;
}

.fees-panel-footer {
  padding: 12px 20px;
  border-top: 1px solid #e0e0e0;
  text-align: right;
}

/* ── Merchant Section ── */
.fees-merchant-section {
  margin-bottom: 24px;
  max-width: 600px;
}

/* ── Fee Groups & Table ── */
.fees-group {
  margin-bottom: 24px;
}

.fees-group-title {
  font-weight: 600;
  color: #2e7d32;
  font-size: 14px;
  margin-bottom: 8px;
}

.fees-table {
  font-size: 13px;
  margin-bottom: 0;
  table-layout: fixed;
  width: 100%;
}

.fees-table thead th {
  width: 25%;
  font-size: 12px;
  text-transform: uppercase;
  color: #777;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  padding: 8px 10px;
  text-align: center;
}

.fees-table tbody td {
  width: 25%;
  padding: 6px 10px;
  vertical-align: middle;
  text-align: center;
}

/* ── Select dropdown fix ── */
.fees-select {
  border: 1px solid #d2d6da !important;
  padding: 6px 30px 6px 10px !important;
  background-position: right 10px center !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* ── Input group with border ── */
.fees-input-group {
  border: 1px solid #d2d6da;
  border-radius: 0.375rem;
  overflow: hidden;
}

.fees-input-group .form-control {
  border: none !important;
  box-shadow: none !important;
  height: auto;
}

.fees-input-group {
  align-items: center;
}

.fees-input-group .input-group-text {
  border: none !important;
  background: #f8f9fa;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
}

/* ── Select2 auto-height ── */
.auto-height .select2-container .select2-selection--multiple {
  min-height: 44px;
  max-height: none !important;
}
</style>
